import type { Location, NodeEntry } from 'slate';
import { Editor, Element, Node, Path } from 'slate';

const inlineQueries = {
  /**
   * Returns a concatenated string of a node's text content.
   */
  getNodeText: (editor: Editor, path: Path): string => {
    const node = Node.get(editor, path);

    return Node.string(node);
  },
  /**
   * Returns an inline entry if there is a single, unique inline in the current selection, or null if not.
   */
  getSelectedInline: (editor: Editor): NodeEntry | null => {
    if (!editor.selection) return null;

    const {
      anchor: { path: anchorPath },
      focus: { path: focusPath },
    } = editor.selection;

    const anchorParent = Node.parent(editor, anchorPath);
    const anchorParentPath = Path.parent(anchorPath);

    const focusParent = Node.parent(editor, focusPath);
    const focusParentPath = Path.parent(focusPath);

    if (
      Element.isElement(anchorParent) &&
      Element.isElement(focusParent) &&
      Editor.isInline(editor, anchorParent) &&
      Editor.isInline(editor, focusParent) &&
      Path.equals(anchorParentPath, focusParentPath)
    ) {
      return [anchorParent, anchorParentPath];
    }

    return null;
  },

  /**
   * Returns a boolean indicating whether the Location passed in has inlines.
   */
  locationHasInlines: (
    editor: Editor,
    options: { at?: Location; voids?: boolean } = {}
  ): boolean => {
    const { at = editor.selection, voids = false } = options;

    if (!at) {
      console.warn(`The at parameter is ${at}.  Pass a valid Location.`);
      return false;
    }

    const inlineEntries = [
      ...Editor.nodes(editor, {
        at,
        match: node => Element.isElement(node) && Editor.isInline(editor, node),
        voids,
      }),
    ];

    return inlineEntries.some(([node]) => Element.isElement(node) && Editor.isInline(editor, node));
  },
};

export default inlineQueries;
